import { render, staticRenderFns } from "./ContractCommercializationSettings.vue?vue&type=template&id=922c6da6&"
import script from "./ContractCommercializationSettings.vue?vue&type=script&lang=js&"
export * from "./ContractCommercializationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports